
import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid } from "@mui/material";
import ImageEditor from "../../libs/imgcrop/ImageEditor";
import ImageResizer from "../extra/ImageResizer";
import CountrySelect from "../extra/CountrySelect";
import { localCountryCode } from "../../libs/Libs";
import XDateRange from "../extra/XDateRange";
import LocInput from "../extra/LocInput";

export default function Form({
    title,
    companies = [],
    defaultValues = {},
    onSubmit = (data) => { },
    onChange = (column, data) => { },
    back = () => { } }) {
    //let country = defaultValues?.country ? defaultValues.country : localCountryCode()
    const [open, setOpen] = React.useState(false)
    const { handleSubmit, control, setValue, watch, clearErrors, setError, formState: { errors }, } = useForm({ defaultValues: defaultValues, mode: "all" })
    const booleanFields = [
        { name: "verify", label: "Verified", watch: watch("verify") },
        { name: "active", label: "Active", watch: watch("active") },
    ];
    return (
        <>
            <Box sx={{ p: 3 }}>
                <form
                    onSubmit={handleSubmit((data) => {
                        console.log("data submit", data)
                        onSubmit(data)
                    })}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
                                <select >
                                    <option value="">Select Company</option>
                                    {companies.map((company) => <option value={company.id}>{company.company_name} </option>)}
                                </select>
                            </RFG>
                            <RFG name="project_name" label="Project Name" control={control} rules={{
                                required: true, maxLength: {
                                    value: 100,
                                    message: `Cannot exceed 100 characters`,
                                },
                                pattern: {
                                    value: /^[A-Za-z0-9\s\-_,.]+$/,
                                    message: "Invalid project name. Allowed: letters, numbers, spaces, - _ ,.",
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Project Name" />
                            </RFG>
                            <RFG name="description" label="Description" control={control} rules={{
                                required: true, maxLength: {
                                    value: 100,
                                    message: `Cannot exceed 100 characters`,
                                },
                                pattern: {
                                    value: /^[A-Za-z0-9\s.,!?'"()\-_:;]*$/,
                                    message: "Invalid description. Allowed: letters, numbers, spaces, & . , - '",

                                }

                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Description" />
                            </RFG>

                            <RFG
                                name="start_project_date"
                                label="Start Date"
                                control={control}
                                rules={{ required: true }}
                                onChange={(e) => { setValue("start_project_date", e.target.value) }} // Updated to use e.target.value
                                className="mb-2"
                            >
                                <input type="date" autoComplete="false" />
                            </RFG>

                            <RFG name="duration" label="Duration in Days:" control={control} rules={{
                                required: true, maxLength: {
                                    value: 30,
                                    message: `Cannot exceed 30 characters`,
                                }
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Duration in Days" />
                            </RFG>
                            <Box className="text">
                                Country
                                <CountrySelect
                                    defaultValue={defaultValues.country}
                                    labelKey="name"
                                    valueKey="code"
                                    //onValueChange={(country) => setValue("country", country.value)}
                                    onValueChange={(country) => {
                                        console.log("asasa", JSON.stringify(country)
                                        )
                                        // Set and validate the same field name
                                        const value = country?.value || "";
                                        const cnty_name = country?.label || "";
                                        setValue("country_name", cnty_name);
                                        setValue("country", value, { shouldValidate: true });
                                        if (value) clearErrors("country");
                                        // no setError here; RHF required rule shows the message on submit
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <LocInput label="Location" name="location" defaultLocation={defaultValues.location} errors={errors}
                                onChange={(place) => {
                                    if (place.display_name) {
                                        let value = `${place.display_name}$${place.lat},${place.lon}`
                                        setValue("location", value || "", { shouldValidate: true });
                                        if (place.display_name) clearErrors("location");
                                    } else {
                                        setError("location", { type: "required", message: "Location is required" });
                                    }
                                }}
                            />

                            {/* <RFG name="location" label="Cordinates" control={control} rules={{
                                required: true
                            }} className="mb-2">
                                <input autoComplete="false" placeholder="Location" />
                            </RFG> */}
                            <Box sx={{ my: 1 }} display="flex" flexWrap="wrap" gap={2}>
                                {booleanFields.map(({ name, label, watch }) => (
                                    <RFG name={name} label={label} control={control} className="mb-2">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => setValue(name, e.target.checked)}
                                            checked={watch}
                                        />
                                    </RFG>
                                ))}
                            </Box>
                            <Box mt={2}>
                                {/* <ImageEditor onChange={(bs64) => setValue("image", bs64)} /> */}
                                <ImageResizer defaultValue={defaultValues.image} onChange={(bs64) => setValue("image", bs64)} />
                            </Box>
                            <Box textAlign="right" sx={{ my: 4 }}>
                                <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                    Back
                                </Button>
                                <Button sx={{ mx: 2 }} className="btn-primary" type="submit">Save</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </>
    )
}